import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Trusted_Brands.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const brands = [
    { id: 1, name: "NEXA", src: "/assets/images/home/trust_brands/nexa.png" },
    { id: 2, name: "BMW", src: "/assets/images/home/trust_brands/bmw.png" },
    { id: 3, name: "MINI", src: "/assets/images/home/trust_brands/mini.png" },
    { id: 4, name: "Mahindra", src: "/assets/images/home/trust_brands/mahindra.png" },
    { id: 5, name: "Unnati Motors", src: "/assets/images/home/trust_brands/nexa.png" },
    { id: 6, name: "Toyota", src: "/assets/images/home/trust_brands/bmw.png" },
    { id: 7, name: "Honda", src: "/assets/images/home/trust_brands/mini.png" },
    { id: 8, name: "Hyundai", src: "/assets/images/home/trust_brands/mahindra.png" },
    { id: 9, name: "Mercedes", src: "/assets/images/home/trust_brands/nexa.png" },
    { id: 10, name: "Audi", src: "/assets/images/home/trust_brands/bmw.png" },
    { id: 11, name: "Volkswagen", src: "/assets/images/home/trust_brands/mini.png" },
    { id: 12, name: "Tata", src: "/assets/images/home/trust_brands/mahindra.png" },
];

const Trusted_Brands = () => {
    return (
        <section className="trusted_brands_section">
           
            <Common_Title pageTitle="Trust" boxText="Trusted By Leading Brands" />

           
            <div className="swiper_wrapper">
                <Swiper
                    modules={[Pagination]}
                    spaceBetween={20}
                    slidesPerView={4}
                    initialSlide={0}
                    loop={false}
                    pagination={{
                        clickable: true,
                        el: ".trusted_dots",
                        bulletClass: "dot",
                        bulletActiveClass: "dot_active",
                    }}
                    breakpoints={{
                        1024: { slidesPerView: 4, spaceBetween: 20 },
                        768: { slidesPerView: 3, spaceBetween: 15 },
                        576: { slidesPerView: 2, spaceBetween: 12 },
                        320: { slidesPerView: 2, spaceBetween: 10 },
                    }}
                    className="trusted_swiper"
                >
                    {brands.map((brand) => (
                        <SwiperSlide key={brand.id}>
                            <div className="brand_card">
                                <img
                                    src={brand.src}
                                    alt={brand.name}
                                    className="brand_logo"
                                    loading="lazy"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Custom pagination dots */}
            <div className="trusted_dots"></div>
        </section>
    );
};

export default Trusted_Brands;